import {
  type CreditCard,
  useCreditCards,
} from "hooks/firestore/user/useCreditCards";
import { useDepositWizard } from "./useDepositWizard";
import type { Maybe } from "types/utilities";

export const useSelectedCard = (): {
  selectedCard: Maybe<CreditCard>;
  isLoading: boolean;
} => {
  const { creditCards, isLoading } = useCreditCards();
  const { selectedCardId } = useDepositWizard();

  if (selectedCardId) {
    const selectedCard = creditCards.find(
      (c) => c.id === selectedCardId && !c.expired,
    );
    return { selectedCard, isLoading };
  }

  return { selectedCard: creditCards.find((c) => !c.expired), isLoading };
};
